import React from 'react';
import {
    Title,
    ImageAd,
    Root,
    Nav,
    Products,
    Divider,
    Text,
    Space,
    NoticeBar,
    SearchBar,
    Showcase,
    CountDown,
    Banner,
    LandscapeImage,
    CommodityTab,
    AdPlayer,
    StaticPicture,
    TitleDescription,
    ImageNav,
    ProductCard,
    ShopWindow,
    HotZone,
    PointSwap,
    PointsDisplay,
    NoticeBarTransverse,
} from './forms';

import { ApplicationConfigForm } from '@comall-backend-builder/design-core';

ApplicationConfigForm.register({
    name: 'root',
    title: '页面设置',
    validate: () => {
        return true;
    },
    render: (data: any, extra: any) => {
        return <Root {...data} extra={extra} />;
    },
});

ApplicationConfigForm.register({
    name: 'titleDescription',
    title: '标题',
    defaultConfig: {
        fontColor: '#303030',
        fontSize: 30,
        align: 'left',
        titleWeight: 'bold',
        describeWeight: 'normal',
        describeColor: '#696969',
        describeSize: 22,
    },
    validate: (profile: any) => {
        const { title } = profile;
        return !!title;
    },
    render: (data: any) => {
        return <TitleDescription {...data} />;
    },
});

ApplicationConfigForm.register({
    name: 'banner',
    title: '轮播图',
    defaultConfig: {
        showStyle: '1',
        fillStyle: '2',
        imageHeight: 300,
        margin: 0,
        marginImage: 20,
        borderRadius: 0,
        bannerMarinTop: 0,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, effectiveTime, uploadAction }) => {
        return (
            <Banner
                {...data}
                uploadAction={uploadAction}
                linkTypes={linkTypes}
                effectiveTime={effectiveTime}
            />
        );
    },
});

ApplicationConfigForm.register({
    name: 'hotZone',
    title: '热区切图',
    defaultConfig: {
        pageMargin: 0,
        imageCir: 0,
        backPic: '',
        entry: [],
        hotZoneList: [],
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, effectiveTime, uploadAction }) => {
        return (
            <HotZone
                {...data}
                uploadAction={uploadAction}
                linkTypes={linkTypes}
                effectiveTime={effectiveTime}
            />
        );
    },
});

ApplicationConfigForm.register({
    name: 'staticPicture',
    title: '静态图片广告',
    defaultConfig: {
        showStyle: '1',
        // fillStyle: '2',
        // imageHeight: 300,
        margin: 16,
        marginImage: 16,
        borderRadius: 0,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, effectiveTime, uploadAction }) => {
        return (
            <StaticPicture
                {...data}
                uploadAction={uploadAction}
                linkTypes={linkTypes}
                effectiveTime={effectiveTime}
            />
        );
    },
});

ApplicationConfigForm.register({
    name: 'landscapeImage',
    title: '横向滑动图片',
    defaultConfig: {
        showStyle: '1',
        fillStyle: '2',
        margin: 16,
        marginImage: 16,
        borderRadius: 20,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, effectiveTime, uploadAction }) => {
        return (
            <LandscapeImage
                {...data}
                uploadAction={uploadAction}
                linkTypes={linkTypes}
                effectiveTime={effectiveTime}
            />
        );
    },
});

ApplicationConfigForm.register({
    name: 'imageNav',
    title: '导航',
    defaultConfig: {
        showStyle: 'image',
        count: 2,
        margin: 0,
        textColor: '#666',
        backColor: '#ffff',
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <ImageNav {...data} uploadAction={uploadAction} linkTypes={linkTypes} />;
    },
});

ApplicationConfigForm.register({
    name: 'shopWindow',
    title: '橱窗',
    defaultConfig: {
        showStyle: '1',
        // height: 200,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <ShopWindow {...data} linkTypes={linkTypes} uploadAction={uploadAction} />;
    },
});

ApplicationConfigForm.register({
    name: 'commodityTab',
    title: 'Tab切换',
    defaultConfig: {
        activeIndex: 0,
        showStyle: 1,
        tabNumber: 1,
        tabList: [
            {
                id: 1,
                tmpId: 1,
                imagePosition: 30,
                imageNumber: 2,
                imageBothSides: 16,
                imageUD: 16,
                pageMargin: 16,
                imageMargin: 16,
                imageBorder: 0,
                imgList: [],
                backgroundImage: '',
                checkImage: '',
                uncheckedImage: '',
            },
            {
                id: 2,
                tmpId: 1,
                imagePosition: 30,
                imageNumber: 2,
                imageBothSides: 16,
                imageUD: 16,
                pageMargin: 16,
                imageMargin: 16,
                imageBorder: 0,
                imgList: [],
                backgroundImage: '',
                checkImage: '',
                uncheckedImage: '',
            },
        ],
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, effectiveTime, uploadAction }) => {
        return (
            <CommodityTab
                {...data}
                uploadAction={uploadAction}
                linkTypes={linkTypes}
                effectiveTime={effectiveTime}
            />
        );
    },
});

ApplicationConfigForm.register({
    name: 'adPlayer',
    title: '视频',
    defaultConfig: {
        showStyle: '1',
        fillStyle: '2',
        commodityPicture: '',
        buyItPicture: '',
        jumpUrl: {
            linkType: 'none',
            linkParams: '',
        },
        purchaseImage: '',
        videoMute: true,
        videoAutoplay: true,
        purchaseShow: true,
        // 背景设置
        bgColor: '#ffffff',
        bgHeight: 967,
        bgMargin: 16,
        bgRadius: 12,
        videoMargin: 0,
        commodityLeft: 18,
        commodityTop: 680,
        purchaseLeft: 386,
        purchaseTop: 881,
        textOneSize: 32,
        textOneColor: '#323233',
        textOneLeft: 346,
        textOneTop: 735,
        textTwoSize: 28,
        textTwoColor: '#323233',
        textTwoLeft: 346,
        textTwoTop: 788,
        textThreeSize: 28,
        textThreeColor: '#323233',
        textThreeLeft: 346,
        textThreeTop: 826,
    },
    validate: (profile: any) => {
        const { videoUrl } = profile;
        return !!Array.isArray(videoUrl) && videoUrl.length;
    },
    render: (data: any, { linkTypes, effectiveTime, uploadAction }) => {
        return (
            <AdPlayer
                {...data}
                uploadAction={uploadAction}
                linkTypes={linkTypes}
                effectiveTime={effectiveTime}
            />
        );
    },
});

ApplicationConfigForm.register({
    name: 'divider',
    title: '辅助线',
    defaultConfig: {
        style: 'solid',
        color: '#ebedf0',
        margin: 'none',
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, extra: any) => {
        return <Divider {...data} {...extra} />;
    },
});

ApplicationConfigForm.register({
    name: 'space',
    title: '辅助空白',
    defaultConfig: {
        height: 40,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, extra: any) => {
        return <Space {...data} {...extra} />;
    },
});

ApplicationConfigForm.register({
    name: 'text',
    title: '文本',
    defaultConfig: {
        fontColor: '#999',
        fontSize: 24,
        align: 'left',
        linkType: 'none',
        margin: 0,
    },
    validate: (data: any) => {
        const { content } = data;
        return !!content;
    },
    render: (data: any, { linkTypes }) => {
        return <Text {...data} linkTypes={linkTypes} />;
    },
});

ApplicationConfigForm.register({
    name: 'searchBar',
    title: '搜索框',
    defaultConfig: {
        linkType: 'none',
        fontColor: '#b6b6b6',
        boxBackgroundColor: '#FFFFFF',
        backgroundColor: '#f6f6f6',
        textAlign: 'left',
        shape: 'square',
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes }) => {
        return <SearchBar {...data} linkTypes={linkTypes} />;
    },
});

ApplicationConfigForm.register({
    name: 'countDown',
    title: '倒计时',
    defaultConfig: {
        showStyle: '1',
        height: 200,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <CountDown {...data} linkTypes={linkTypes} uploadAction={uploadAction} />;
    },
});

ApplicationConfigForm.register({
    name: 'noticeBar',
    title: '通知栏',
    defaultConfig: {
        fontColor: '#ED6A0C',
        backgroundColor: '#fffbe8',
        linkType: 'none',
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <NoticeBar {...data} linkTypes={linkTypes} uploadAction={uploadAction} />;
    },
});

ApplicationConfigForm.register({
    name: 'noticeBarTransverse',
    title: '通知栏(横向滚动)',
    defaultConfig: {
        fontColor: '#ED6A0C',
        backgroundColor: '#fffbe8',
        linkType: 'none',
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <NoticeBarTransverse {...data} linkTypes={linkTypes} uploadAction={uploadAction} />;
    },
});

ApplicationConfigForm.register({
    name: 'productCard',
    title: '商品',
    defaultConfig: {
        showStyle: '1',
        showContent: ['buy', 'name', 'price', 'marketPrice', 'finishGrade'],
        showContentBox: ['buy', 'name', 'price', 'marketPrice', 'finishGrade'],
        showContentColor: {
            price: '#8c6057',
            marketPrice: '#747474',
        },
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <ProductCard {...data} uploadAction={uploadAction} linkTypes={linkTypes} />;
    },
});

ApplicationConfigForm.register({
    name: 'pointSwap',
    title: '积分兑换',
    defaultConfig: {
        bgPic: '',
        pageMargin: 0,
        bgRoundedCorners: 0,
        productTab_activeTabImage: '',
        productTab_inactiveTabImage: '',
        productTab_pointsProduct: [],
        productTab_showData: ['name', 'price'],
        productTab_color: '#000',
        couponTab_activeTabImage: '',
        couponTab_inactiveTabImage: '',
        couponTab_coupons: [],
    },
    validate: (data: any) => {
        const {
            productTab_activeTabImage,
            productTab_inactiveTabImage,
            productTab_pointsProduct,
            couponTab_activeTabImage,
            couponTab_inactiveTabImage,
            couponTab_coupons,
        } = data;

        return (
            productTab_activeTabImage &&
            productTab_inactiveTabImage &&
            productTab_pointsProduct.length &&
            couponTab_activeTabImage &&
            couponTab_inactiveTabImage &&
            couponTab_coupons.length
        );
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <PointSwap {...data} linkTypes={linkTypes} uploadAction={uploadAction} />;
    },
});

ApplicationConfigForm.register({
    name: 'pointsDisplay',
    title: '积分展示',
    defaultConfig: {
        pageMargin: 0,
        bgRoundedCorners: 0,
        showStyle: 1,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <PointsDisplay {...data} linkTypes={linkTypes} uploadAction={uploadAction} />;
    },
});

// 2023年之前的组件 用于兼容历史数据使用
ApplicationConfigForm.register({
    name: 'title',
    title: '标题(旧)',
    defaultConfig: {
        fontColor: '#000',
        fontSize: 32,
        align: 'left',
    },
    validate: (profile: { title: any }) => {
        const { title } = profile;
        return !!title;
    },
    render: (data: any) => {
        return <Title {...data} />;
    },
});

ApplicationConfigForm.register({
    name: 'imageAd',
    title: '图片广告(旧)',
    defaultConfig: {
        showStyle: '1',
        fillStyle: '2',
        imageHeight: 300,
        margin: 0,
        marginImage: 20,
        borderRadius: 0,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, effectiveTime, uploadAction }) => {
        return (
            <ImageAd
                {...data}
                uploadAction={uploadAction}
                linkTypes={linkTypes}
                effectiveTime={effectiveTime}
            />
        );
    },
});

ApplicationConfigForm.register({
    name: 'nav',
    title: '导航(旧)',
    defaultConfig: {
        showStyle: 'image',
        count: 5,
        margin: 0,
        textColor: '#666',
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <Nav {...data} uploadAction={uploadAction} linkTypes={linkTypes} />;
    },
});
ApplicationConfigForm.register({
    name: 'showcase',
    title: '橱窗(旧)',
    defaultConfig: {
        showStyle: '1',
        height: 200,
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <Showcase {...data} linkTypes={linkTypes} uploadAction={uploadAction} />;
    },
});

ApplicationConfigForm.register({
    name: 'products',
    title: '商品(旧)',
    defaultConfig: {
        showStyle: '1',
        showContent: ['buy', 'name', 'price'],
        showContentColor: {
            price: '#d21820',
            marketPrice: '#dcdcdc',
        },
    },
    validate: (data: any) => {
        return new Promise(function(resolve) {
            resolve(data);
        });
    },
    render: (data: any, { linkTypes, uploadAction }) => {
        return <Products {...data} uploadAction={uploadAction} linkTypes={linkTypes} />;
    },
});
